module.exports = __webpack_public_path__ + "img/top02.51c89843.jpg";